package com.macrofocus.eflux

import web.cssom.px

object Sizes {
    object Header {
        val Height = 60.px
    }

    object Sidebar {
        val Width = 300.px
    }

    object Fabbar {
        val Width = 184.px
    }
}